<template>
  <div :class="{ 'iframe-mode': isInIframe }">
    <v-toolbar flat color="white" class="elevation-1">
      <div class="inline-flex w-64">
        <v-select
          class="ml-2 pt-3"
          :items="orderBy"
          clearable
          :placeholder="$t('message.LicensesManager.orderBy')"
          item-text="label"
          item-value="value"
          v-model="columnSelected"
          @change="orderList()"
          solo
          flat
          data-vs-select="orderBy"
        ></v-select>
        <button class="order-button" @click="changeOrderType" data-vs-button="changeOrderType">
          <zt-icon
            :name="pagination.descending ? 'arrow-down-2' : 'arrow-up'"
            class="pt-2"
            :class="primaryTextClass"
          />
        </button>
      </div>
      <v-spacer></v-spacer>
      <zt-button
        @click="exportData"
        :loader="exportLoading"
        :loaderTxt="$t('message.LicensesManager.search.exportLoading')"
        outlined
        icon="box-arrow-down"
        :disabled="exportLoading"
        data-vs-button="exportData"
        >{{ $t('message.LicensesManager.search.export') }}</zt-button
      >
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="this.state.results"
      :expand="expand"
      item-key="index"
      class="elevation-1"
      :rows-per-page-items="[8, 15, 30]"
      :pagination.sync="pagination"
      @update:pagination="updatePagination"
      :total-items="this.state.total"
      :loading="loading"
      :no-data-text="$t('message.datatable.noDataText')"
    >
      <template v-slot:items="props">
        <tr>
          <td @click="props.expanded = !props.expanded" data-vs-button="expand" class="cursor-pointer">
            <zt-icon :name="props.expanded ? 'angle-down' : 'angle-right'" />
          </td>
          <td>
            <p class="text-zt-base text-zt-dark-500">
              {{ props.item.nombre }} {{ props.item.apellido }}
            </p>
          </td>
          <td class="text-zt-base text-zt-dark-500">
            {{ props.item.numero_legajo }}
          </td>
          <td class="text-zt-base text-zt-dark-500">{{ props.item.sector }}</td>
          <td class="text-zt-base text-zt-dark-500">
            {{ props.item.locacion }}
          </td>
          <td class="text-zt-base text-zt-dark-500">
            {{ props.item.nombre_tipo }}
          </td>
          <td class="text-zt-base text-zt-dark-500">{{ trunc(props.item.dias) }}</td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card flat>
          <v-card-text class="pl-16">
            <p class="font-bold">
              {{ $t('message.LicensesManager.search.balanceDetail') }}:
            </p>
            <span v-html="parseDetails(props.item.detalles)"></span>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
export default {
  inject: ['state', 'mutations'],
  data() {
    return {
      results: this.state.results,
      resultsTotal: this.state.total,
      loading: false,
      exportLoading: false,
      pagination: this.state.pagination,
      expand: false,
      headers: [
        { text: '', sortable: false },
        {
          text: `${this.$t('message.LicensesManager.search.nameLastname')}`,
          align: 'left',
          sortable: false,
          value: 'nombre'
        },
        {
          text: `${this.$t('message.LicensesManager.search.fileNumber')}`,
          sortable: false,
          align: 'left',
          value: 'numero_legajo'
        },
        {
          text: `${this.$t('message.LicensesManager.search.sector')}`,
          sortable: false,
          align: 'left',
          value: 'sector'
        },
        {
          text: `${this.$t('message.LicensesManager.search.location')}`,
          sortable: false,
          align: 'left',
          value: 'locacion'
        },
        {
          text: `${this.$t('message.LicensesManager.search.type')}`,
          sortable: false,
          align: 'left',
          value: 'dias'
        },
        {
          text: `${this.$t('message.LicensesManager.search.days')}`,
          sortable: false,
          align: 'left',
          value: 'nombre_tipo'
        }
      ],
      columnSelected: '',
      orderBy: [
        {
          value: 'name',
          label: this.$t('message.LicensesManager.search.name')
        },
        {
          value: 'surname',
          label: this.$t('message.LicensesManager.search.surname')
        },
        {
          value: 'type',
          label: this.$t(
            'message.LincensesHistorySummaryComponent.labels.licenseType'
          )
        },
        {
          value: 'sector',
          label: this.$t('message.LicensesManager.search.sector')
        },
        {
          value: 'location',
          label: this.$t('message.LicensesManager.search.location')
        },
        {
          value: 'days',
          label: this.$t('message.LincensesHistorySummaryComponent.labels.days')
        }
      ]
    }
  },
  created() {
    this.licenses = new Licenses()
  },
  computed: {
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    }
  },
  mounted () {
    this.updatePagination();
  },
  methods: {
    updatePagination(pagination) {
      if (this.state.pagination.totalItems) {
        this.search()
      }
    },
    search() {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination

      this.mutations.setPagination(this.pagination)

      this.licenses
        .searchBalances(
          this.state.filters,
          this.state.pagination.rowsPerPage,
          this.state.pagination.page,
          this.state.pagination.sortBy,
          this.state.pagination.descending
        )
        .then(response => {
          this.mutations.setResults(response.data.results.data)
          this.mutations.setTotalResults(response.data.pagination.total)
          this.pagination.totalItems = response.data.pagination.total
          this.mutations.setPagination(this.pagination)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
        })
    },
    orderList() {
      this.pagination.sortBy = this.columnSelected
      this.search()
    },
    changeOrderType() {
      this.pagination.descending = !this.pagination.descending
      this.search()
    },
    exportData() {
      this.exportLoading = true
      this.mutations.setPagination(this.pagination)

      this.licenses
        .exportBalances(
          this.state.filters,
          this.state.pagination.sortBy,
          this.state.pagination.descending
        )
        .then(response => {
          let request = response.request
          let disposition = request.getResponseHeader('content-disposition')
          let matches = /"([^"]*)"/.exec(disposition)
          let filename =
            matches != null && matches[1] ? matches[1] : 'results.xls'
          // The actual download
          var blob = new Blob([request.response], {
            type: 'application/vnd.ms-excel;charset=utf-8'
          })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.exportLoading = false
        })
        .catch(err => {
          this.exportLoading = false
          this.$swal({
            type: 'error',
            title: this.$t(
              `message.errorReference.${error.response.data.response_v2.code}`
            ),
            showConfirmButton: true,
            confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
          })
        })
    },
    bkparseDetails(value) {
      let parsed = value.replace(/{|}|"/gi, '').split(',')
      let newArr = []
      parsed.forEach(element => {
        if (!element.match(/\d{4}/)) {
          newArr.push(
            `${this.$t('message.LicensesManager.balances.woBalance')}`
          )
          return
        }
        newArr.push(
          element.replace(':d:', this.$t('message.LicensesManager.search.days'))
        )
      })
      return newArr.join('<br>')
    },
    parseDetails(value) {
      const details = value.replace(/{|}|"/gi, '').split(',')
      let formatDetails = []
      details.forEach(element => {
          if (!element.match(/\d{4}/)){
              formatDetails.push(
                `${this.$t('message.LicensesManager.balances.woBalance')}`
              );
          } else {
              formatDetails.push(this.formatLine(element.split(/:/)))
          }
      });
      return formatDetails.join("<br>");
    },
    formatLine(lineParts) {
      return `${lineParts[0]}: ${this.trunc(lineParts[1].trim())} días`
    },
    trunc(numb) {
      const numbToString = Number.parseFloat(numb).toFixed(20)
      const decimalLength = numbToString.indexOf('.') + 1
      const trunc = numbToString.substr(0, decimalLength + 2)
      return decimalLength === 0 ? Number(numbToString) : Number(trunc)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep table.v-table {
  thead th:first-child {
    padding: 0 0 0 14px;
  }
  tbody td:first-child {
    padding: 0 0 0 14px;
  }
}
.order-button {
  outline: none;
}

/* Estilos para modo iframe */
.iframe-mode {
  ::v-deep .zt-button {
    background-color: #2694fc !important;
    border-color: #2694fc !important;
    color: white !important;
    
    &:hover {
      background-color: #1e7fd4 !important;
      border-color: #1e7fd4 !important;
    }
    
    &.zt-button--outlined {
      background-color: transparent !important;
      color: #2694fc !important;
      border-color: #2694fc !important;
      
      &:hover {
        background-color: rgba(38, 148, 252, 0.1) !important;
      }
    }
  }

  ::v-deep .v-progress-linear {
    // Background del progress bar
    .v-progress-linear__background.primary {
      background-color: rgba(38, 148, 252, 0.3) !important;
    }
    
    // Barras indeterminadas con clase primary
    .v-progress-linear__bar__indeterminate.long.primary,
    .v-progress-linear__bar__indeterminate.short.primary {
      background-color: #2694fc !important;
    }
    
    // Por si acaso, también sobrescribir sin la clase primary
    .v-progress-linear__bar__indeterminate {
      &.long, &.short {
        background-color: #2694fc !important;
      }
    }
    
    // Barra determinada
    .v-progress-linear__bar__determinate {
      background-color: #2694fc !important;
    }
  }
  
  ::v-deep .v-datatable__actions {
    .v-select {
      .v-input__slot {
        color: inherit !important;
      }
      
      .v-select__selection {
        color: inherit !important;
      }
    }
  }
}

// Fix global para la lista desplegable del paginador - solo el ítem activo
::v-deep .v-menu__content {
  .v-list__tile--active {
    color: #2694fc !important;
    
    .primary--text {
      color: #2694fc !important;
    }
  }
}

.text-iframe-primary {
  color: #2694fc !important;
}
</style>
